import { Provider } from 'react-redux';
import store from '../../../store';
import NotificationAlert from './';

const component = props => (
    <Provider store={store}>
        <NotificationAlert {...props} />
    </Provider>
);
export default component;
